export { LayerBox } from './LayerBox';

// Fix me: Missing theme handling
export var THEME_COLOR = '#006ce8';